import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild, inject, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  DxButtonModule,
  DxDataGridModule,
  DxFileUploaderModule,
  DxFormModule,
  DxNumberBoxModule,
  DxPopoverModule,
  DxPopupModule,
  DxSelectBoxModule,
  DxTextAreaModule,
  DxTextBoxModule,
  DxToastModule,
} from 'devextreme-angular';
import { CommentService } from 'src/app/services/comment.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AppGlobals } from 'src/app/app.globals';
import { TechnicalComponentsService } from 'src/app/services/tech-components.service';
import { DxDataGridComponent } from 'devextreme-angular';
import { FileViewerComponent } from 'src/app/components/file-viewer/file-viewer.component';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { LoggingService } from 'src/app/services/logging.service';
import { environment } from 'src/environments/environment';
import { DeletePopupComponent } from '../../../components/delete-popup/delete-popup.component';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { GpdButtonComponent } from 'src/app/components/gpd-button/gpd-button.component';
import { GpdPaginationComponent } from 'src/app/components/gpd-pagination/gpd-pagination.component';
import {
  ComponentDetailsPanelComponent,
  ComponentDetail,
  DocLink,
  SiteInfo,
  ProjectInfo,
} from 'src/app/components/component-details-panel/component-details-panel.component';
import { AppConfig } from 'src/app/app.config';
import { GenericPopupComponent, PopupButton } from 'src/app/components/generic-popup/generic-popup.component';
import { ActivityLogService } from 'src/app/services/activity-log.service';
import { ActivitySection } from 'src/app/constants/activity-log';
import { ApiFileService } from 'src/app/services/api-file.service';
@Component({
    selector: 'app-project-info-components',
    templateUrl: './grid-connection-components.page.html',
    styleUrls: ['./grid-connection-components.page.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CommonModule,
        DxTextAreaModule,
        DxButtonModule,
        DxFormModule,
        DxDataGridModule,
        DxPopupModule,
        DxSelectBoxModule,
        DxFileUploaderModule,
        DxTextBoxModule,
        DxNumberBoxModule,
        DxToastModule,
        FileViewerComponent,
        DeletePopupComponent,
        GpdButtonComponent,
        GpdPaginationComponent,
        ComponentDetailsPanelComponent,
        GenericPopupComponent,
    ]
})
export class GridConnectionComponentsPage implements OnInit, AfterViewInit, OnDestroy {
  private readonly apiFileService = inject(ApiFileService);

  // #region Properties
  type: any = '';
  message: any = '';
  toastVisible: boolean = false;

  searchTerm: string = AppGlobals.searchPanelText;
  addComponentSearchTerm: string = '';

  @ViewChild(DxDataGridComponent, { static: false }) dataGridSearch: DxDataGridComponent;
  @ViewChild('dataGridSearch2', { static: false }) dataGridSearch2: DxDataGridComponent;

  minPopupHeight: any = '600px';

  contentLoadedVisible: boolean = true;
  popUpTitle: any = '';

  editTitle: any = $localize`:@@editGridConnectionComponent:Edit Grid Connection Component`;

  editComponentVisible: boolean = false;

  editNotesVisible: boolean = false;

  allowDeletingVisible: boolean = false;

  addNewComponentVisible: boolean = false;

  uploadDocumentVisible: boolean = false;

  addComponentVisible: boolean = false;

  popupVisible: boolean = false;

  amountVisible: boolean = false;

  gridConnectionComponentList: any = [];

  componentTypeList: any = [];
  selectedComponentType: any = null;

  componentList: any = [];

  companyList: any = [];

  selectedComponentQuantity: any = '';

  selectedComponent: any = {};
  selectedComponentToAdd: any = {};

  componentTypes: any = [];
  pageSize: number = 0;

  deleteFunction: Function | null = null;

  @ViewChild(FileViewerComponent) fileViewer: FileViewerComponent;
  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;

  projectId: Number;
  gridConnectionId: Number;
  siteQuantity: number = 0;
  newestComponentId: any = '';
  projectNotes: any = '';

  itemsPerPage: number = 0;
  currentPage: number = 0;
  totalPages: number = 0;
  totalItems: number = 0;

  selectedComponentIdForDocUpload: any = '';
  noDataText: any = $localize`:@@noDataText:No data`;
  public Math = Math;

  dynamicPageSize: number = 10;
  availableHeight: number = 400; // Dynamic grid height

  private resizeHandler = () => this.calculateDynamicPageSize();

  // Details Panel Properties
  detailsPanelVisible: boolean = false;
  detailsPanelHeight: number = 500;
  componentDetails: ComponentDetail[] = [];
  doclinks: DocLink[] = [];
  componentId: number | null = null;
  documentList: any[] = [];
  sitesForPanel: SiteInfo[] = [];
  projectsForPanel: ProjectInfo[] = [];
  disableDownloadAll: boolean = true;
  downloadLinks: any[] = [];
  // #endregion

  constructor(
    private commentService: CommentService,
    private activatedRoute: ActivatedRoute,
    private technicalComponentsService: TechnicalComponentsService,
    private appGlobals: AppGlobals,
    private utilities: UtilitiesService,
    private loggingService: LoggingService,
    private router: Router,
    private activityLog: ActivityLogService
  ) {}

  editPopupLeftButtons: PopupButton[] = [];
  editPopupButtons: PopupButton[] = [];

  get addPopupButtons(): PopupButton[] {
    return [
      { text: $localize`:@@cancel:Cancel`, type: 'secondary', icon: 'cancel', onClick: () => this.closeAddComponent() },
      { text: $localize`:@@confirm:Confirm`, type: 'primary', icon: 'tick', disabled: !this.showQuantityInput, onClick: () => this.addTechComponentToGridConnection() },
    ];
  }

  async ngOnInit() {
    this.editPopupLeftButtons = [
      { text: $localize`:@@delete:Delete`, type: 'danger', icon: 'delete', onClick: () => this.deleteComponent() },
    ];
    this.editPopupButtons = [
      { text: $localize`:@@cancel:Cancel`, type: 'secondary', icon: 'cancel', onClick: () => this.closePopup() },
      { text: $localize`:@@save:Save`, type: 'primary', icon: 'tick', onClick: () => this.saveComponent() },
    ];
    this.searchTerm = '';
    this.activityLog.logView({
      Section: ActivitySection.SITE_COMPONENTS,
      SiteId: Number(this.activatedRoute.snapshot.params.id),
    });
    this.getPageData();

    if (environment.isTestEnvironment === true) {
      this.appGlobals.SetGlobalMenuIndex(1);
    } else {
      this.appGlobals.SetGlobalMenuIndex(1);
    }
  }

  ngAfterViewInit(): void {
    this.calculateDynamicPageSize();
    this.getGridPageInfo();
    window.addEventListener('resize', this.resizeHandler);
  }

  ngOnDestroy() {
    window.removeEventListener('resize', this.resizeHandler);
    if (this.rowClickTimer) {
      clearTimeout(this.rowClickTimer);
    }
  }

  private calculateDynamicPageSize(): void {
    // Get viewport height
    const viewportHeight = window.innerHeight;

    // Estimate heights (matching technical-components approach)
    const reservedSpace = 250; // header nav, page header, filters, margins
    const toolbarHeight = 60; // bottom toolbar
    const headerHeight = 40; // grid header
    const rowHeight = 40; // Approximate height of each row

    // Calculate available height for grid content
    this.availableHeight = viewportHeight - reservedSpace - toolbarHeight - 80;
    this.detailsPanelHeight = this.availableHeight;

    // Calculate how many rows can fit
    const contentHeight = this.availableHeight - headerHeight;
    const calculatedPageSize = Math.floor(contentHeight / rowHeight);

    // Set minimum and maximum bounds
    this.dynamicPageSize = Math.max(10, Math.min(calculatedPageSize, 1000));

    // Update the grid if it's already initialized
    if (this.dataGridSearch?.instance) {
      this.dataGridSearch.instance.pageSize(this.dynamicPageSize);
      this.dataGridSearch.instance.refresh();
      this.getGridPageInfo();
    }
  }

  // #region Get Page Data
  componentTypeForFilter: any = [];
  async getPageData() {
    this.gridConnectionId = Number(this.activatedRoute.snapshot.params.id);
    await this.technicalComponentsService.getCompanies({}).then(
      result => {
        if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
        else {
          this.companyList = result.companyList;
        }
      },
      (error: any) => {
        AppGlobals.ShowErrorMessage(error);
      }
    );

    await this.technicalComponentsService.getGridConnectionTechComponentList({}).then(
      result => {
        if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
        else {
          this.componentList = result.components.sort((a, b) => {
            const modelA = a.model || '';
            const modelB = b.model || '';
            return modelA.localeCompare(modelB);
          });
          this.componentTypes = result.componentTypes;
          this.componentTypeForFilter = this.componentTypes
            .filter(type => this.componentList.some(comp => Number(comp.typeId) === Number(type.id)))
            .sort((a, b) => a.name.localeCompare(b.name));
        }
      },
      (error: any) => {
        AppGlobals.ShowErrorMessage(error);
      }
    );

    this.getComponentDocsList();
    this.getAllDocLinks();
    this.reloadPageGrid(0);
  }

  getComponentDocsList(): void {
    this.technicalComponentsService.getComponentTypeDocs({}).then(result => {
      this.documentList = result.documents;
    });
  }

  getAllDocLinks(): void {
    this.technicalComponentsService.getAllDocumentLink({}).then(result => {
      this.doclinks = result.componentDocData;
    });
  }

  filterBySelectedComponentType(): void {
    if (this.selectedComponentType) {
      // Apply filter to the DataGrid by typeId
      this.dataGridSearch.instance.filter(['typeId', '=', this.selectedComponentType]);
    } else {
      // Clear filter if no type is selected
      this.dataGridSearch.instance.clearFilter();
    }
  }

  getGridPageInfo(): void {
    if (!this.dataGridSearch?.instance) {
      console.warn('DataGrid not initialized');
      return;
    }

    this.currentPage = this.dataGridSearch.instance.pageIndex() + 1;
    this.totalPages = this.dataGridSearch.instance.pageCount();
    this.itemsPerPage = this.dataGridSearch.instance.pageSize();
    this.totalItems = this.dataGridSearch.instance.totalCount();
  }

  /**
   * Returns the current page index (1-based for display)
   */
  getCurrentPage(): number {
    if (this.dataGridSearch?.instance) {
      return this.dataGridSearch.instance.pageIndex() + 1;
    }
    return 1;
  }

  onGridOptionChanged(e: any): void {
    if (e.fullName === 'paging.pageIndex' || e.fullName === 'paging.pageSize' || e.fullName === 'dataSource') {
      this.getGridPageInfo();
    }
  }

  /**
   * Advances to the next page in the data grid
   */
  goToNextPage(): void {
    if (this.dataGridSearch?.instance) {
      const currentIndex = this.dataGridSearch.instance.pageIndex();
      const totalPages = this.dataGridSearch.instance.pageCount();

      if (currentIndex < totalPages - 1) {
        this.dataGridSearch.instance.pageIndex(currentIndex + 1);
        // Force update
        setTimeout(() => this.getGridPageInfo(), 100);
      }
    }
  }

  goToPreviousPage(): void {
    if (this.dataGridSearch?.instance) {
      const currentIndex = this.dataGridSearch.instance.pageIndex();

      if (currentIndex > 0) {
        this.dataGridSearch.instance.pageIndex(currentIndex - 1);
        // Force update
        setTimeout(() => this.getGridPageInfo(), 100);
      }
    }
  }

  get showingFrom(): number {
    if (this.totalItems === 0) return 0;
    return this.itemsPerPage * (this.currentPage - 1) + 1;
  }

  get showingTo(): number {
    return Math.min(this.itemsPerPage * this.currentPage, this.totalItems);
  }

  gridConnectionDatasheets: any = []; // <-- Add this line
  reloadPageGrid(preloadId: number): void {
    let payload = {
      GridConnectionId: this.gridConnectionId,
    };

    this.technicalComponentsService.getGridConnectionTechComponents(payload).then(
      result => {
        if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
        else {
          this.gridConnectionComponentList = result.components.sort((a, b) => a.model.localeCompare(b.model));

          this.componentTypeList = result.componentTypes;
          this.componentTypeForFilter = this.componentTypes
            .filter(type => this.gridConnectionComponentList.some(comp => Number(comp.typeId) === Number(type.id)))
            .sort((a, b) => a.name.localeCompare(b.name));
          this.gridConnectionDatasheets = result.gridConnectionDatasheets;

          // Map datasheet info to each component
          this.gridConnectionComponentList.forEach(component => {
            const datasheetEntry = this.gridConnectionDatasheets?.find(
              ds => ds.componentId === component.componentId && ds.gridConnectionId === component.gridConnectionId
            );
            component.hasDataSheet = !!datasheetEntry;
            component.dataSheetName = datasheetEntry?.dataSheet || null;
          });

          if (preloadId !== 0) {
            let preloadRecord: any = null;

            // FIX: Check both 'id' and 'Id' to handle inconsistent casing
            this.gridConnectionComponentList.forEach((allocation: any) => {
              if (allocation.id === preloadId || allocation.Id === preloadId) {
                preloadRecord = allocation;
              }
            });

            if (preloadRecord != null) {
              this.editComponent(preloadRecord);
            }
          }
        }
      },
      (error: any) => {
        AppGlobals.ShowErrorMessage(error);
      }
    );
  }

  async reloadComponentList() {
    await this.technicalComponentsService.getGridConnectionTechComponentList({}).then(
      result => {
        if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
        else this.componentList = result.components;
      },
      (error: any) => {
        AppGlobals.ShowErrorMessage(error);
      }
    );
  }

  // #endregion

  // #region Handle Pop-ups
  closePopup(): void {
    if (this.rowClickTimer) {
      clearTimeout(this.rowClickTimer);
      this.rowClickTimer = null;
    }
    this.popupVisible = false;
    this.searchTerm = '';
    this.addNewComponentVisible = false;
    this.addComponentVisible = false;
    this.editComponentVisible = false;
    this.popupVisible = false;
    this.uploadDocumentVisible = false;
    this.amountVisible = false;
    this.minPopupHeight = '600px';
    this.selectedComponent = {
      manufacturerName: '',
      manufacturerId: null,
      typeId: null,
      model: '',
      powerRating: '',
      siteQuantity: 0,
      notes: '',
      serialNumber: '',
      ipAddress: '',
    };
  }

  // Opens a component on grid double click
  editComponent(data: any): void {
    if (this.rowClickTimer) {
      clearTimeout(this.rowClickTimer);
      this.rowClickTimer = null;
    }
    this.detailsPanelVisible = false;
    this.editActionTriggered = true;
    this.closePopup();

    // Set to null first to force form recreation
    this.selectedComponent = {};

    // Create fresh object with data
    this.selectedComponent = {
      manufacturerName: '',
      manufacturerId: null,
      typeId: null,
      model: '',
      powerRating: '',
      siteQuantity: 0,
      notes: '',
      serialNumber: '',
      ipAddress: '',
      componentId: null,
      id: null,
    };

    this.selectedComponent = { ...data, quantity: { format: this.formatterGerman } };

    this.popupVisible = true;
    this.popUpTitle = this.editTitle;
    this.editComponentVisible = true;
    this.addNewComponentVisible = false;
  }

  addNewComponent(): void {
    // Close popup first to ensure clean state
    this.closePopup();

    // Force a complete reset of the selectedComponent object
    this.selectedComponent = null;

    // Small delay to ensure popup is fully closed and form is destroyed
    setTimeout(() => {
      // Create a fresh object
      this.selectedComponent = {
        manufacturerName: '',
        manufacturerId: null,
        typeId: null,
        model: '',
        powerRating: '',
        siteQuantity: 0,
        notes: '',
        serialNumber: '',
        ipAddress: '',
        componentId: null,
        id: null,
      };

      this.minPopupHeight = '';
      this.popUpTitle = $localize`:@@addNewComponent:Add New Component`;
      this.addNewComponentVisible = true;
      this.popupVisible = true;
    }, 50);
  }
  // #endregion

    // #region Save component details for grid conneciton 
    saveComponent(): void {
            // Validation: quantity must be greater than 0
        if (!this.selectedComponent || this.selectedComponent.siteQuantity == null || this.selectedComponent.siteQuantity <= 0) {
            AppGlobals.ShowErrorMessage($localize`:@@enterValidQuantity:Please enter a valid quantity greater than zero.`);
      return;
    }

        let payload = {
            "Id": this.selectedComponent.id,
            "GridConnectionId": this.gridConnectionId,
            "ComponentId": this.selectedComponent.componentId,
            "IPAddress": this.selectedComponent.ipAddress,
            "SerialNumber": this.selectedComponent.serialNumber,
            "SiteQuantity": this.selectedComponent.siteQuantity ?? 0,
            "Notes": this.selectedComponent.notes ?? ''
        }


        this.technicalComponentsService.editGridConnectionTechComponent(payload).then((result) => {
            if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
            else {
                let success = true;
                this.saveToast({ type: success, feedback: $localize`:@@componentSaved:Component Saved` });
                this.closePopup();
                setTimeout(() => { this.reloadPageGrid(0); }, 100);
            }
        },
            (error: any) => {
                AppGlobals.ShowErrorMessage(error);
            });
    }
    // #endregion

  // #region Save a new component
  async saveNewComponent() {
    let componentItem = { ...this.selectedComponent };
    const existing = this.gridConnectionComponentList.find((c: any) => c.ComponentId === componentItem.componentId);
    const existingQty = existing && existing.SiteQuantity ? Number(existing.SiteQuantity) : 0;
    const newQty = componentItem.siteQuantity ? Number(componentItem.siteQuantity) : 0;
    componentItem.siteQuantity = String(existingQty + newQty);

    console.clear();

    componentItem.siteQuantity = componentItem.siteQuantity != null ? String(componentItem.siteQuantity) : '';

    let newComponent = {
      ComponentItem: componentItem,
    };

    this.newestComponentId = 0;

    await this.technicalComponentsService.addTechComponent(newComponent).then(
      result => {
        if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
        else {
          let success = true;
          this.saveToast({ type: success, feedback: $localize`:@@componentSaved:Component Saved` });
          this.newestComponentId = result.componentId;
          this.reloadComponentList();
        }
      },
      (error: any) => {
        AppGlobals.ShowErrorMessage(error);
      }
    );

    let componentToAdd = {
      GridConnectionId: this.gridConnectionId,
      ComponentId: this.newestComponentId,
      IPAddress: '',
      SerialNumber: '',
    };

    // if (this.newestComponentId === 0) return;
    // this.closePopup();

    this.technicalComponentsService.addTechComponentToGridConnection(componentToAdd).then(
      result => {
        if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
        else {
          var success = true;
          this.saveToast({ type: success, feedback: $localize`:@@componentAdded:Component Added` });
          this.closePopup();
          this.reloadPageGrid(result.AllocationId);
        }
      },
      (error: any) => {
        AppGlobals.ShowErrorMessage(error);
      }
    );
  }

  // #endregion

  // #region Quantity selected
  amountSelected(): void {
    return;
  }
  // #endregion

  addComponent(): void {
    this.searchTerm = '';

    this.showQuantityInput = false;
    this.addComponentVisible = true;

    setTimeout(() => {
      if (this.selectedComponentType) {
        this.dataGridSearch2.instance.filter(['typeId', '=', this.selectedComponentType]);
      } else {
        this.dataGridSearch2.instance.clearFilter();
      }
    }, 200);

    this.selectedComponent = {
      manufacturerName: '',
      manufacturerId: null,
      typeId: null,
      model: '',
      powerRating: '',
      siteQuantity: 0,
      notes: '',
      serialNumber: '',
      ipAddress: '',
    };
  }

  addComponentToGridConnection(e: any): void {
    this.popupVisible = false;
    this.addComponentVisible = false;
  }

  // #region Remove a component from a Grid Connection
  deleteComponent(): void {
    this.selectedComponent = this.selectedComponent || {};
    let payload = {
      Id: this.selectedComponent.id,
      GridConnectionId: this.selectedComponent.siteId,
      ComponentId: this.selectedComponent.componentId,
    };
    this.technicalComponentsService.removeTechComponentFromGridConnection(payload).then(
      result => {
        if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
        else {
          var success = true;
          this.saveToast({ type: success, feedback: $localize`:@@componentDelete:Component Deleted` });
          this.reloadPageGrid(0);
        }
      },
      (error: any) => {
        AppGlobals.ShowErrorMessage(error);
      }
    );
    this.editComponentVisible = false;
  }
  // #endregion

  showQuantityInput: boolean = false;
  selectedComponentForAdd: any = {};
  selectedRow: any[] = [];

  private editActionTriggered: boolean = false;

    onRowClick(e: any): void {
        if (!e.data.isCompleted) return;
        this.selectedComponentForAdd = e;
        this.showQuantityInput = true;
        this.selectedRow = [e.data.componentId];
    }

  addTechComponentToGridConnection(): void {
    this.showQuantityInput = false;
    this.searchTerm = null;

    if (this.siteQuantity <= 0) {
      AppGlobals.ShowErrorMessage($localize`:@@enterValidQuantity:Please enter a valid quantity greater than zero.`);
      this.showQuantityInput = true;
      return;
    }
    let componentToAdd = {
      GridConnectionId: this.gridConnectionId,
      ComponentId: this.selectedComponentForAdd.data.componentId,
      IPAddress: '',
      SerialNumber: '',
      Notes: '',
      SiteQuantity: this.siteQuantity,
    };

    this.technicalComponentsService.addTechComponentToGridConnection(componentToAdd).then(
      result => {
        if (result.hasError === true) {
          if (typeof result.feedback === 'string' && result.feedback.trim().endsWith('2')) {
            this.closePopup();
            this.showErrMsg = true;
            this.errMsg = result.feedback.replace(/\s*2$/, '').trim();
            this.selectedComponentToAdd = this.selectedComponentForAdd.data;
          } else {
            AppGlobals.ShowErrorMessage(result.feedback);
          }
        } else {
          var success = true;
          this.saveToast({ type: success, feedback: $localize`:@@componentAdded:Component Added` });
          this.closePopup();
          this.reloadPageGrid(0);
        }
      },
      (error: any) => {
        AppGlobals.ShowErrorMessage(error);
      }
    );
  }

  selectComponent(e: any): void {
    this.closePopup();
    this.selectedComponent = null;

    let componentToAdd = {
      GridConnectionId: this.gridConnectionId,
      ComponentId: e.data.componentId,
      IPAddress: '',
      SerialNumber: '',
      Notes: '',
      SiteQuantity: 0,
    };

    this.technicalComponentsService.addTechComponentToGridConnection(componentToAdd).then(
      result => {
        if (result.hasError === true) {
          if (typeof result.feedback === 'string' && result.feedback.trim().endsWith('2')) {
            this.showErrMsg = true;
            this.errMsg = result.feedback.replace(/\s*2$/, '').trim();
            this.selectedComponentToAdd = e.data;
          } else {
            AppGlobals.ShowErrorMessage(result.feedback);
          }
        } else {
          var success = true;
          this.saveToast({ type: success, feedback: $localize`:@@componentAdded:Component Added` });
          // Just reload the grid without opening edit popup
          this.reloadPageGrid(result.AllocationId);
        }
      },
      (error: any) => {
        AppGlobals.ShowErrorMessage(error);
      }
    );
  }

  uploadDocument(e: any): void {
    const file: File = e.value[0];
    if (file) {
      if (file.name.length > AppConfig.MaxFileNameLength) {
        AppGlobals.ShowErrorMessage(
          $localize`:@@fileNameTooLongError:File name is too long. Maximum allowed length is ${AppConfig.MaxFileNameLength}:maxLength: characters.`
        );
        return;
      }
      const formData = new FormData();
      this.selectedComponentIdForDocUpload = parseInt(this.selectedComponent.componentId);
      formData.append('fileBytes', e.value[0]);
      formData.append('componentId', this.selectedComponentIdForDocUpload);
      formData.append('fileBytesFileName', e.value[0].name);

      this.technicalComponentsService.addTechComponentDataSheet(formData).then(
        result => {
          if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
          else {
            var success = true;
            this.saveToast({ type: success, feedback: $localize`:@@uploadComplete:Upload Complete` });
            if (this.uploadDocumentVisible === true) {
              this.closePopup();
              location.reload();
            }
          }
        },
        (error: any) => {
          AppGlobals.ShowErrorMessage(error);
        }
      );
    }
  }

  uploadDoc(e: any): void {
    const file: File = e.value[0];
    if (file) {
      const formData = new FormData();
      formData.append('GridConnectionId', String(this.gridConnectionId)); // Add GridConnectionId
      formData.append('ComponentId', String(this.selectedComponent.componentId));
      formData.append('FileBytesFileName', file.name);
      formData.append('FileBytes', file);
      formData.append('FileBytesContentType', file.type);

      this.technicalComponentsService.addGridConnectionComponentDataSheet(formData).then(result => {
        if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
        else {
          var success = true;
          this.saveToast({ type: success, feedback: $localize`:@@uploadComplete:Upload Complete` });
          if (this.uploadDocumentVisible === true) {
            this.closePopup();
            location.reload();
          }
        }
      });
    }
  }

  noUploadDoc(): void {
    location.reload();
  }

  saveToast(e: any): void {
    const type = e.type ? 'success' : 'error';
    if ((this.type = 'success')) {
      this.message = e.feedback;
    } else {
      AppGlobals.ShowErrorMessage($localize`:@@errorTryAgain:ERROR: There was an error, please try again.`);
    }
    this.type = type;
    this.toastVisible = true;
  }

  hasSelectedComponentDatasheet(): boolean {
    if (!this.selectedComponent) return false;
    return this.gridConnectionDatasheets?.some(
      ds =>
        ds.componentId === this.selectedComponent.componentId && ds.gridConnectionId === this.selectedComponent.siteId
    );
  }

  removeDocument(componentId: any): void {
    let techComponent = {
      GridConnectionId: this.gridConnectionId,
      ComponentId: componentId,
    };

    this.technicalComponentsService.removeGridConnectionComponentDatasheet(techComponent).then(
      result => {
        if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
        else {
          let success = true;
          this.saveToast({ type: success, feedback: $localize`:@@documentRemoved:Document removed` });
          this.closePopup();
          this.reloadPageGrid(0);
        }
      },
      (error: any) => {
        AppGlobals.ShowErrorMessage(error);
      }
    );
  }

  // #region Search Grids
  doSearch(e: any): void {
    this.contentLoadedVisible = false;
    this.searchTerm = e.value;
    if (this.searchTerm.length < 2) {
      if (this.dataGridSearch) {
        this.dataGridSearch.instance.searchByText('');
        this.appGlobals.setSearchPanelText('');
        this.contentLoadedVisible = true;
      }
      return;
    }
    if (this.dataGridSearch) {
      this.dataGridSearch.instance.searchByText(this.searchTerm);
      this.appGlobals.setSearchPanelText(this.searchTerm);
      this.contentLoadedVisible = true;
    }
  }
  // #endregion

  formatterGerman(e: any) {
    if (e != undefined) {
      return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(e);
    }
  }
  changeFormatOptionGermanNumber(input: string): void {
    this.selectedComponent[input].format = this.formatterGerman;
  }
  changeFormatOptionGermanNumberBack(input: string): void {
    this.selectedComponent[input].format = null;
  }

  downloadTechDoc(docName: string): void {
    this.technicalComponentsService.downloadTechComponentDocumentByFileName({ FileName: docName }).then(result => {
      this.downloadFileFromBytes(result.fileName, result.fileBytes, result.contentType);
    });
  }

  downloadFileFromBytes(fileName: string, base64Bytes: string, contentType: string): void {
    // Convert base64 to Uint8Array
    const binaryString = window.atob(base64Bytes);
    const bytes = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }

    // Create Blob
    const blob = new Blob([bytes], { type: contentType });
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.open(url, '_blank');
  }

  showErrMsg: boolean = false;
  errMsg: string = '';
  goToComponentLibrary(): void {
    if (this.selectedComponentToAdd) {
      this.router.navigate(['/tech-components'], {
        queryParams: { componentId: this.selectedComponentToAdd.componentId },
      });
    } else {
      this.router.navigate(['/tech-components']);
    }
  }

  closeErrMsg(): void {
    this.showErrMsg = false;
    this.errMsg = '';
  }

  showAllComponents(): void {
    this.selectedComponentType = null;
    if (this.dataGrid?.instance) {
      this.dataGrid.instance.clearFilter();
    }
  }

  exportComponentData(): void {
    if (!this.dataGridSearch?.instance) {
      console.warn('DataGrid not initialized');
      return;
    }

    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Grid Connection Components');

    exportDataGrid({
      component: this.dataGridSearch.instance,
      worksheet: worksheet,
      autoFilterEnabled: true,
    }).then(() => {
      workbook.xlsx.writeBuffer().then(buffer => {
        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'GridConnectionComponents.xlsx');
        this.loggingService.logFileExport(buffer, 'GridConnectionComponents.xlsx', {
          section: ActivitySection.SITE_COMPONENTS,
          siteId: this.gridConnectionId ? Number(this.gridConnectionId) : null,
        });
      });
    });

    // Show success message
    this.saveToast({
      type: true,
      feedback: $localize`:@@exportComplete:Export Complete`,
    });
  }

  closeAddComponent(): void {
    this.addComponentSearchTerm = '';
    this.showQuantityInput = false;
    this.addComponentVisible = false;
  }

  // Add Component Grid Pagination
  addComponentCurrentPage: number = 1;
  addComponentTotalPages: number = 1;
  addComponentItemsPerPage: number = 0;
  addComponentTotalItems: number = 0;

  get addComponentShowingFrom(): number {
    if (this.addComponentTotalItems === 0) return 0;
    return this.addComponentItemsPerPage * (this.addComponentCurrentPage - 1) + 1;
  }

  get addComponentShowingTo(): number {
    return Math.min(this.addComponentItemsPerPage * this.addComponentCurrentPage, this.addComponentTotalItems);
  }

  getAddComponentGridPageInfo(): void {
    if (!this.dataGridSearch2?.instance) {
      return;
    }
    this.addComponentCurrentPage = this.dataGridSearch2.instance.pageIndex() + 1;
    this.addComponentTotalPages = this.dataGridSearch2.instance.pageCount();
    this.addComponentItemsPerPage = this.dataGridSearch2.instance.pageSize();
    this.addComponentTotalItems = this.dataGridSearch2.instance.totalCount();
  }

  onAddComponentGridOptionChanged(e: any): void {
    if (e.fullName === 'paging.pageIndex' || e.fullName === 'paging.pageSize' || e.fullName === 'dataSource') {
      this.getAddComponentGridPageInfo();
    }
  }

  onAddComponentPageChange(page: number): void {
    if (this.dataGridSearch2?.instance) {
      this.dataGridSearch2.instance.pageIndex(page - 1);
      this.getAddComponentGridPageInfo();
    }
  }

  onPageChange(page: number): void {
    if (this.dataGrid?.instance) {
      this.dataGrid.instance.pageIndex(page - 1);
      this.getGridPageInfo();
    }
  }

  get totalItemsForSelectedType(): number {
    if (this.dataGridSearch?.instance) {
      return this.dataGridSearch.instance.totalCount();
    }
    return this.gridConnectionComponentList.length;
  }

  // Details Panel Methods
  private rowClickTimer: any = null;

  onComponentRowClick(e: any): void {
    if (e.event && e.event.target && e.event.target.closest('.edit-button')) {
      return;
    }

    if (this.rowClickTimer) {
      clearTimeout(this.rowClickTimer);
      this.rowClickTimer = null;
      this.editComponent(e.data);
      return;
    }

    this.rowClickTimer = setTimeout(() => {
      this.rowClickTimer = null;
      this.showDetailsPanel(e.data);
    }, 250);
  }

  showDetailsPanel(data: any): void {
    this.componentId = data.componentId;
    this.detailsPanelVisible = true;
    this.editComponentVisible = false;
    this.getComponentDetails(data);
    this.getDocsForThisComponent();
    this.calculateDetailsPanelHeight();
  }

  closeDetailsPanel(): void {
    this.detailsPanelVisible = false;
  }

  async getComponentDetails(data: any): Promise<void> {
    // Set initial details immediately (fixed fields only)
    this.componentDetails = [
      {
        model: data.model,
        manufacturerName: data.manufacturerName,
        type: data.type,
        status: data.status || 'Active',
        dataFields: [
          { fieldName: $localize`:@@siteQuantity:Site Quantity`, value: data.siteQuantity?.toString() || '0' },
        ],
      },
    ];

    // Fetch dynamic data fields from the API and append them
    this.technicalComponentsService.getComponentWithDataFields({ ComponentId: data.componentId }).then(result => {
      if (!result.hasError && result.componentDetails?.length > 0) {
        const apiFields: { fieldName: string; value: string }[] = (result.componentDetails[0].dataFields ?? []).map(
          (f: any) => ({ fieldName: f.fieldName, value: f.value ?? '' })
        );
        if (apiFields.length > 0) {
          this.componentDetails = [
            {
              ...this.componentDetails[0],
              dataFields: [
                { fieldName: $localize`:@@siteQuantity:Site Quantity`, value: data.siteQuantity?.toString() || '0' },
                ...apiFields,
              ],
            },
          ];
        }
      }
    });
  }

  getDocsForThisComponent(): void {
    const payload = {
      TechComponentId: this.componentId,
    };

    this.technicalComponentsService.getTechComponentDocs(payload, false).then(result => {
      this.downloadLinks = result.componentDocData;
      this.disableDownloadAll = this.filteredDownloadLinks.length === 0;
    });
  }

  get filteredDownloadLinks(): any[] {
    if (!this.downloadLinks || !this.componentId) return [];
    return this.downloadLinks.filter(dl => dl.docLink && dl.componentId === this.componentId);
  }

  calculateDetailsPanelHeight(): void {
    // Use the same height as the grid
    this.detailsPanelHeight = this.availableHeight;
  }

    onEditFromPanel(): void {
        const component = this.gridConnectionComponentList.find(c => c.componentId === this.componentId);
        if (component) {
            this.detailsPanelVisible = false;
            this.editComponent(component);
        }
    }

    onRowPrepared(e: any): void {
        if (e.rowType === 'data' && e.data && !e.data.isCompleted) {
            e.rowElement.classList.add('component-incomplete');
        }
    }

  downloadAllDocs(): void {
    const componentId = this.componentId;
    this.technicalComponentsService.downloadAllComponentDocuments({ componentId }).then(result => {
      if (result.hasError) {
        AppGlobals.ShowErrorMessage(result.feedback);
        return;
      }
      this.apiFileService.downloadTempFile(result.downloadId, result.downloadFileName);
    });
  }
}
